import script from "./SecondMikatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondMikatPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondMikatPage.vue?vue&type=style&index=0&id=1ef0c1e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef0c1e2"]])

export default __exports__